<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-03-18 17:22:48
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-04-19 10:36:38
 * @FilePath: \front\src\views\System\syncPatient.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="about">
        <div class="pg-header">
			<div><label class="title">补抓患者</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span>数据管理</span>|
					<span>补抓患者</span>
				</div>
			</div>
		</div>
        <div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<!-- <label>姓名<el-input size="small" maxlength="6" style="width:160px;margin:0 16px 0 4px;" v-model.trim="filter.name"></el-input></label> -->
                        <div>
                            <div style="display: inline-block;">查询类型
                                <el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType" @change="handleFilter(1, $event)">
                                    <el-option v-for="item in opList1" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            
                            <label v-if="filter.dataType==1">p-his-id<el-input size="small"  style="width:160px;margin:0 16px 0 4px;" v-model.trim="filter.patientHisId"></el-input></label>
                            <label v-if="filter.dataType==3">his-id<el-input size="small"  style="width:160px;margin:0 16px 0 4px;" v-model.trim="filter.hisId"></el-input></label>
                            <div style="display: inline-block;" v-if="filter.dataType==1||filter.dataType==2||filter.dataType==3">来源
                                <el-select size="small" filterable clearable placeholder="请选择" v-model="filter.datasources" @change="handleFilter(3, $event)">
                                    <el-option v-for="item in oplist2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <label v-if="timelabel">
                                {{ timelabel }}
                                <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:260px;" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="dates" :picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
                            </label>
                        </div>
                        <div>
                            <el-button size="mini" round @click="resetevt" style="margin-left: 12px;">重置</el-button>
                            <el-button v-if="filter.dataType!=5" size="mini" round style="margin-left: 12px;" @click="searchevt">查询</el-button>
                        </div>
					</div>
				</el-form>
			</div>
        </div>
        <div class="botwrap">
            <div>
                <div style="display: flex; justify-content: space-between;">
                    <h1>患者接口返回结果:</h1>
                    <div id="findwindow"></div>
                </div>
                <div id="contentMain" v-text="data?.returnResult" ></div>
                <h2 v-if="data.syncStatus!=0">补抓状态:{{ {0:'未同步',1:'待同步',2:'同步中',3:'同步成功',4:'同步失败',5:'查询失败'}[data.syncStatus]}}</h2>
                <p style="text-align:center">
                    <el-button type="primary" v-if="data.returnResult||(filter.dataType==5&&dates)" @click="searchevt('add')">补抓数据</el-button>
                </p>
            </div>
        </div>
        <el-dialog title="补抓数据" label-position="left" width="500px" :visible.sync="active" :close-on-click-modal="false">
			<div style="text-align:center;color: #616161;">系统开始补抓数据，请耐心等待<br>
                补抓详情可在系统管理-数据管理-补抓记录中查看</div>
			<div slot="footer" style="text-align:center;">
				<el-button type="primary" @click="closeDlg">确 定</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import initFindWin from "find5";
export default {
	mixins: [mixin],
    data(){
        return {
            filter: {
                datasources:null,
                dataType:null,
                endTime:'',
                startTime:'',
                hisId:'',
                id:null,
                operateType:1,
                patientHisId:'',
                patientId:null,
            },
            opList1:[
                {
                    "id": 1,
                    "name": "患者信息"
                },
                {
                    "id": 2,
                    "name": "就诊记录"
                },
                {
                    "id": 3,
                    "name": "诊断信息"
                },
                {
                    "id": 4,
                    "name": "检验检查"
                },
                {
                    "id": 5,
                    "name": "复诊履约"
                }

            ],
            oplist2:[
                {
                    "id": 0,
                    "name": "住院"
                },
                {
                    "id": 1,
                    "name": "门诊"
                },
                {
                    "id": 2,
                    "name": "出院"
                },
            ],
            timelabel:'',
            data:{},
            active:false,
            dates:null,
        }
    },
    mounted(){
        initFindWin(false, "contentMain");
    },
    methods: {
        closeDlg(){
            this.active=false;
        },
        async loadData(type){
           
            let res=await api.getSyncData(this.filter);
            if(res.code==1000){
                if(this.filter.dataType==1&&type!='add'){
                    this.data=res.data[0]
                }else{
                    this.data=res.data;
                }
            }else{
                this.$message.error(res.message);
            }
        },
        searchevt(type){
            if(!this.filter.dataType){
                this.$message.error('请选择查询类型');
            }else if((this.filter.dataType==2||this.filter.dataType==1||this.filter.dataType==3)&&this.filter.datasources==null){
                this.$message.error('请选择来源');
            }else if(this.filter.dataType==1&&!this.filter.patientHisId){
                this.$message.error('请输入p-his-id');
            }else if(this.filter.dataType==3&&!this.filter.hisId){
                this.$message.error('请输入his-id');
            }else if(((this.filter.dataType==2&&this.filter.datasources!=0)||this.filter.dataType==4||this.filter.dataType==5)&&!this.dates){
                this.$message.error('请选择时间范围');  
            }
            else {
                if(type=='add'){
                    if(this.data&&this.filter.dataType==1){
                        let obj = JSON.parse(this.data?.inputParams);
                        this.filter.patientHisId=obj?.patientHisId;
                    }
                    this.filter.operateType=2;
                    this.active=true;
                }
                this.loadData(type);
            }
        },
        resetevt(){
            for (let key in this.filter) {
                this.filter[key] = null;
            }
            this.filter.operateType=1;
            this.timelabel='';
            this.dates=null;
            this.data={};
        },
        // 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 2:
					if (this.dates) {
						this.filter.startTime = dayjs(this.dates[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.endTime = dayjs(this.dates[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.startTime = '';
						this.filter.endTime = '';						
					}
					break;
                case 1:
                    this.resetevt();
                    this.filter.dataType=val;
                    break;
			}
            switch(this.filter.dataType){
                case 4:
                    this.timelabel='检查时间';
                    break;
                case 5:
                    this.timelabel='复诊时间';
                    break;
                case 2:
                    if(this.filter.datasources==1){
                        this.timelabel='门诊时间';
                    }else if(this.filter.datasources==2){
                        this.timelabel='出院时间';
                    }else{
                        this.timelabel='';
                    }
                    break;
                default:
                    this.timelabel='';
                    break;
            }
            this.data.syncStatus=0;
        },	
        
    }
}
</script>

<style lang="less" scoped>
    .def-key{
        justify-content: space-between;
    }
    .botwrap{
        background: #fff;
        margin-right: 5px;
        margin-top:20px;
        padding: 30px 0 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        h1,h2{
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            margin-bottom: 12px;
            overflow-y:auto;
        }
        #contentMain{
            width: 617px;
            height: 449px;
            border: 1px solid #ccc;
            padding: 12px;
            overflow: auto;
        }
    }

</style>